import { render, staticRenderFns } from "./insurance-topup-text.vue?vue&type=template&id=531925ee"
import script from "./insurance-topup-text.vue?vue&type=script&lang=js"
export * from "./insurance-topup-text.vue?vue&type=script&lang=js"
import style0 from "./insurance-topup-text.vue?vue&type=style&index=0&id=531925ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports